document.addEventListener('DOMContentLoaded', function () {
    const trackingId = 'cardthrone0f-20';
    const links = document.querySelectorAll('a[href*="amazon.com"], a[href*="amzn.to"]');

    links.forEach(link => {
        try {
            let url = new URL(link.href);

            if (url.searchParams.has('tag')) {
                url.searchParams.set('tag', trackingId); // Overwrite existing if any (optional, strictly speaking maybe we shouldn't overwrite if it's someone else's, but for own site usually yes)
            } else {
                url.searchParams.append('tag', trackingId);
            }

            link.href = url.toString();

            // Add 'sponsored' attribute for SEO best practices for affiliate links
            link.setAttribute('rel', 'sponsored noopener noreferrer');
            link.setAttribute('target', '_blank'); // Open in new tab

        } catch (e) {
            console.error('Failed to convert amazon link:', link.href, e);
        }
    });
});
